import { useEffect } from 'react'

const preventDefault = (event: Event) => event.preventDefault()
const removeListeners = (event: Event) => {
  event.target?.removeEventListener('wheel', preventDefault)
  event.target?.removeEventListener('blur', removeListeners)
}

/**
 * In WebKit browsers, if the cursor is on top of an <input type="number">
 * and you scroll the mouse wheel, the field value will be incremented
 *
 * We don't want this behaviour. Users might erroneosly change important
 * values when scrolling through long forms.
 *
 * This solution will listen to new focus events in the app, if the focused
 * element is <input type="number"> we disable scrolling on the element.
 * As soon the input loses focus we remove this override.
 */
export function usePreventNumberInputScroll(): void {
  useEffect(() => {
    document.body.addEventListener(
      'focus',
      (event) => {
        const target = event.target as HTMLInputElement | null

        if (target?.tagName === 'INPUT' && target.type === 'number') {
          target.addEventListener('wheel', preventDefault)
          target.addEventListener('blur', removeListeners)
        }
      },

      // Important, the listener captures the event before any event.stopPropagation()
      { capture: true }
    )
  }, [])
}
